import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { StarIcon } from 'lucide-react';
export function TestimonialSection() {
  const testimonials = [{
    quote: 'Pensé que ya sabía todo esto. El problema era que nunca lo tuve organizado de esta forma. Ahora lo consulto antes de cada clase y la diferencia es enorme.',
    name: 'Mariana G.',
    role: 'Profesora de Ed. Física',
    initials: 'MG'
  }, {
    quote: 'Lo abro 5 minutos antes de clase. Músculo agonista, plano anatómico, errores frecuentes — todo está ahí. Me cambió la forma de responder frente a mis alumnos.',
    name: 'Lucas R.',
    role: 'Entrenador Personal',
    initials: 'LR'
  }, {
    quote: 'Lo compré sin saber si iba a aplicar igual en mi contexto. Aplica exactamente igual. La terminología es clara y el contenido técnico es impecable.',
    name: 'Florencia M.',
    role: 'Profesora de Ed. Física',
    initials: 'FM'
  }, {
    quote: 'En menos de una hora lo tenía todo claro. El material es directo, técnico y aplicable desde el primer día. No hay que estudiar nada — está todo listo para usar.',
    name: 'Diego S.',
    role: 'Instructor de Musculación',
    initials: 'DS'
  }, {
    quote: 'Pensé que iba a ser material genérico. El nivel técnico me sorprendió. Justifica el precio con creces — y eso que lo compré con el 60% de descuento.',
    name: 'Carla P.',
    role: 'Entrenadora Personal',
    initials: 'CP'
  }, {
    quote: 'Antes improvisaba y mis alumnos lo notaban. Ahora tengo el criterio para responder cualquier pregunta técnica. La diferencia en cómo me perciben es notable.',
    name: 'Javier L.',
    role: 'Entrenador Personal',
    initials: 'JL'
  }, {
    quote: 'Lo recomendé a tres colegas. Todos dicen lo mismo — no sabían que necesitaban esto hasta que lo tuvieron. Es el recurso que faltaba en nuestra formación.',
    name: 'Sebastián V.',
    role: 'Profesor de Ed. Física',
    initials: 'SV'
  }, {
    quote: 'El atlas de selección me cambió la forma de armar las sesiones. Ahora elijo cada ejercicio con criterio real — no por intuición sino por fundamento técnico.',
    name: 'Jimena L.',
    role: 'Entrenadora Personal',
    initials: 'JL'
  }, {
    quote: 'Tengo 6 años de experiencia y encontré cosas que no tenía claras. No importa tu nivel — si nunca tuviste todo esto organizado en un solo lugar, lo necesitás.',
    name: 'Andrés M.',
    role: 'Instructor de Musculación',
    initials: 'AM'
  }];
  return <section className="py-12 bg-background-dark border-y border-card-border-dark" data-id="element-396">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-397">
        <FadeIn className="text-center mb-10" data-id="element-398">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-white font-heading mb-2" data-id="element-399">
            Lo que dicen los profesionales
          </h2>
          <h3 className="text-4xl md:text-5xl lg:text-6xl font-black text-primary font-heading" data-id="element-400">
            que ya tienen su Base Técnica:
          </h3>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-401">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={0.1 * (index % 3)} direction="up" data-id="element-402">
              <div className="bg-card-dark border border-primary/30 rounded-2xl p-6 h-full flex flex-col hover:border-primary/60 transition-colors" data-id="element-403">
                <div className="flex gap-1 mb-6" data-id="element-404">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-405" />)}
                </div>

                <div className="flex items-center gap-4 mb-6" data-id="element-406">
                  <div className="w-12 h-12 rounded-full bg-primary flex items-center justify-center text-black font-bold text-lg shrink-0" data-id="element-407">
                    {testimonial.initials}
                  </div>
                  <div data-id="element-408">
                    <h4 className="font-bold text-white text-lg" data-id="element-409">
                      {testimonial.name}
                    </h4>
                    <span className="text-xs text-gray-400" data-id="element-410">
                      {testimonial.role}
                    </span>
                  </div>
                </div>

                <p className="text-white text-lg leading-relaxed flex-1" data-id="element-411">
                  "{testimonial.quote}"
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}